module.exports = __webpack_public_path__ + "img/f_08.5596483.png";